export default __webpack_public_path__ + "locales/si/FormFillingTipsDialog.json?hash=93a2afb4a8deef249865e87756442447";